import {API_URL} from "../config";
import axios from "../utils/axios";

class FineRepository
{
    getAll(filter) {
        return axios.get(API_URL + "/Fine/List?", { params: filter });
    }

    export(filter) {
        return axios.get(API_URL + "/Fine/Export?",
            {
                params: filter,
                responseType: 'blob'
            });
    }
}

export default FineRepository;